module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_ie8-dom-define.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_ie8-dom-define.js
// module chunks = 6